import React from "react";
import styles from "./PricingCards.module.css";
import PricingCard from "./PricingCard";

const PricingCards = ({ billing ,setIsRegisterOpen}) => {
  const plans = [
    {
      name: "Free",
      monthly: "₹0",
      yearly: "₹0",
      buttonText: "GET STARTED",
      features: [
        "1 Admin access",
        "Up to 10 users access",
        "Admin dashboard",
        // "Email support",
        "Monthly maintenance entry",
        "Resident directory",
        // "Email notifications",
        "Basic expense tracking"
      ]
    },
    {
      name: "Basic",
      // monthly: "₹100",
      yearly: "₹1,499",
      buttonText: "UPGRADE NOW",
      features: [
        "2 Admin access",
        "Up to 25 users access",
        "Advanced dashboard",
        // "Priority email support",
            "Monthly maintenance entry",
        "Resident & owner management",
        "Expense & income tracking",
        "Monthly financial reports"
      ]
    },
    {
      name: "Plus +",
      // monthly: "₹250",
      yearly: "₹3,999",
      buttonText: "UPGRADE NOW",
      popular: true,
      features: [
        "3 Admin access",
        "Unlimited users",
        "All Professional features",
        // "Cloud backup & recovery",
        // "Vendor & staff management",
        "Resident & owner management",
        "Expense & income tracking",
        "Monthly financial reports",
        "Complaint & ticket management",
        // "Automated reminders & alerts",
        "Advanced financial reports",
        // "Data backup & security",
        // "Dedicated account support"
      ]
    }
  ];

  return (
    <div className={styles.cards}>
      {plans.map((plan, index) => (
        <PricingCard
        setIsRegisterOpen={setIsRegisterOpen} 
          key={index}
          name={plan.name}
          price={billing === "monthly" ? plan.monthly : plan.yearly}
          billing={billing}
          popular={plan.popular}
          features={plan.features}
          buttonText={plan.buttonText}   
        //  pass features 
        />
      ))}
    </div>
  );
};

export default PricingCards;
